/**
 * Feature 103 (The Key pilot) / Feature 102 (Request a call): decides which
 * contact-action surface a profile/card's "Message Provider" and
 * "Request a call" buttons should drive to.
 *
 * The Key providers (intakeFormUrl set) keep their intake-form bypass
 * unchanged. Every other provider gets 'call-request' as the primary action
 * (Feature 102), with a secondary Calendly "Schedule Consultation" surface
 * when calendlyUrl is set.
 *
 * Only eligible callers (CARE_SEEKER + guest + WORKSPACE_OPERATIONS, per
 * feature-103 spec ticket 16) get branched to the intake form or offered the
 * Calendly secondary — everyone else (FP, SP, other roles) resolves to the
 * plain 'call-request' primary so their existing behavior is untouched.
 */

export type ContactAction = 'intake-form' | 'call-request';

export type ContactActions = {
  /** What the primary consultation button opens. */
  primary: ContactAction;
  /** Whether a secondary "Schedule Consultation" (Calendly) action exists. */
  hasCalendlySecondary: boolean;
};

export type ContactActionProvider = {
  intakeFormUrl?: string | null;
  calendlyUrl?: string | null;
};

export function useContactAction(
  provider: ContactActionProvider | undefined,
  isEligible: boolean,
): ContactActions {
  if (isEligible && provider?.intakeFormUrl) {
    return { primary: 'intake-form', hasCalendlySecondary: false };
  }
  return {
    primary: 'call-request',
    hasCalendlySecondary: isEligible && !!provider?.calendlyUrl,
  };
}
